import {Injectable} from '@angular/core';
import Pusher from 'pusher-js';
import PusherJS from 'pusher-js';
import {environment} from '../../../environments/environment';
import Echo from 'laravel-echo';

declare var window: any;

window.Pusher = Pusher;

@Injectable({
  providedIn: 'root'
})

export class EchoService {

  public headers: any;
  private echo!: Echo<any>;

  public execute(): Echo<any>  {
    if (!this.echo) {
      const echoConfig = {
        broadcaster: 'reverb' as 'reverb',
        key: '723981b1b4b3b3f7b3b3',
        wsHost: window.location.hostname,
        forceTLS: false,
        enabledTransports: ['ws','wss'] as any,
        authEndpoint: environment.apiUrl + '/auth/pusherjs-login'
      };

      // Use window.Echo if available (for tests), otherwise use new Echo()
      if (typeof window.Echo === 'function') {
        this.echo = window.Echo(echoConfig);
      } else {
        this.echo = new Echo(echoConfig);
      }
    }

    return this.echo;
  }
}
